<template>
    <div class="tab-content">
        <medication-form
            v-show="activeTab === 'network'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="getPatientHipaaForms"
        ></medication-form>

        <email-form
            v-show="activeTab === 'email'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="getPatientHipaaForms"
        ></email-form>

        <fax-form
            v-show="activeTab === 'fax'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="getPatientHipaaForms"
        ></fax-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import MedicationForm from 'components/forms/medication-network/MedicationForm'
    import EmailForm from 'components/forms/email-request/EmailForm'
    import PatientRecordsAPI from '../../../api/PatientRecordsAPI'
    import FaxForm from 'components/forms/fax/FaxForm'

    export default {
        mixins: [FormMixin, HandleRequestMixin],
        components: {
            MedicationForm,
            EmailForm,
            FaxForm,
        },
        props: {
            activeTab: { type: String, required: true },
        },

        data() {
            return {
                availHipaaForms: [],
                recordTypeSources: [],
                hipaaFormsLoaded: false,
                recordTypeSourcesLoaded: false,
                mountedTabs: {
                    network: false,
                    email: false,
                    hipaa: false,
                },
            }
        },

        methods: {
            ensureHipaaForms() {
                if (this.hipaaFormsLoaded) {
                    return
                }
                this.getPatientHipaaForms()
            },
            ensureRequestFormData() {
                this.ensureHipaaForms()
                if (this.recordTypeSourcesLoaded) {
                    return
                }
                this.getRecordTypeSources()
            },
            getPatientHipaaForms() {
                PatientRecordsAPI.getHipaaFormList(this.$auth.getActiveMember()?.id, this.$route.params.id).then((res) => {
                    this.availHipaaForms = res
                    this.hipaaFormsLoaded = true
                })
            },
            getRecordTypeSources() {
                PatientRecordsAPI.getRecordTypeSources().then((res) => {
                    this.recordTypeSources = res.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
                    this.recordTypeSourcesLoaded = true
                })
            },
        },

        mounted() {
            this.ensureRequestFormData()
        },
    }
</script>
